import { ETerrainTypes, TLocation, TMapTile } from "./mapTypes";

export default function generateMap(width: number, height: number): TMapTile[][] {
    const map: TMapTile[][] = Array.from({ length: height }, () => Array(width).fill({ terrain: "desert" }));
  
     // Generate large areas of terrain
    for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
        const random = Math.random();
        if (random < 0.6) {
            map[y][x] = { Terrain: ETerrainTypes.Desert };
        } else if (random < 0.8) {
            map[y][x] = { Terrain: ETerrainTypes.Plains };
        } else if (random < 0.9) {
            map[y][x] = { Terrain: ETerrainTypes.Hills };
        } else {
            map[y][x] = { Terrain: ETerrainTypes.Mountains };
        }
        }
    }

    // Smooth transitions by checking neighbors
    for (let y = 1; y < height - 1; y++) {
        for (let x = 1; x < width - 1; x++) {
            const neighbors = [
                map[y - 1][x],
                map[y + 1][x],
                map[y][x - 1],
                map[y][x + 1],
            ];
            
            const terrainCounts = neighbors.reduce((acc, tile) => {
                acc[tile.Terrain] = (acc[tile.Terrain] || 0) + 1;
                return acc;
            }, {} as Record<ETerrainTypes, number>);
            
            
            const dominantTerrain = Object.keys(terrainCounts).reduce((a, b) =>
            terrainCounts[a as unknown as ETerrainTypes] > terrainCounts[b as unknown as ETerrainTypes]
                ? a
                : b
            ) as unknown as ETerrainTypes;
            
            
            if (terrainCounts[dominantTerrain] >= 3) {
                map[y][x] = { Terrain: dominantTerrain };
            }
        }
    }
    
    return map;
  };

  //We'll probably need this a lot, so making it a general function.
  export function calcDistance(firstLoc: TLocation, secondLoc: TLocation)
  {
    //calculate the distance between two points, using Pythagoras
    return Math.sqrt(Math.abs(firstLoc.x - secondLoc.x) ** 2 + Math.abs(firstLoc.y - secondLoc.y) ** 2) 
  }

  //need an equality comparator for locations.
  export function AreSameLocation(firstLoc: TLocation | undefined, secondLoc:TLocation | undefined){
    if (!firstLoc || !secondLoc) return false; //undefined locations are not the same
    return firstLoc.x === secondLoc.x && firstLoc.y === secondLoc.y
  }

